import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NowcastRainfallComponent } from './nowcast-rainfall.component';
import { SharedModule } from '../../shared/shared.module';
import { DataService } from '../nowcast-rainfall/utils/service/data.service';
import { MapService } from '../nowcast-rainfall/utils/service/map.service';
import { NowcastRainfallService } from './utils/service/nowcast-rainfall.service';



@NgModule({
  declarations: [NowcastRainfallComponent],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [NowcastRainfallComponent],
  providers: [DataService, MapService, NowcastRainfallService]
})
export class NowcastRainfallModule { }
